import { RoutePlanStatus } from './RoutePlanStatus';

/** A row in the route-plans list (`GET shipment-planning/route-plan`). */
export class RoutePlanSummary {
  id?: number;
  status: RoutePlanStatus = RoutePlanStatus.DRAFT;
  shipmentCount = 0;
  originSummary?: string;
  destSummary?: string;
  executedDate?: string;
  createdBy?: string;
  createdDate?: string;

  constructor(opts?: Partial<RoutePlanSummary>) {
    Object.assign(this, opts);
  }
}
